import { motion } from "framer-motion";
import { Search, ExternalLink, BadgeCheck, ArrowDown } from "lucide-react";

const steps = [
  {
    icon: Search,
    title: "Paste the listing URL",
    description: "Copy any Airbnb listing link and paste it into our search tool.",
  },
  {
    icon: ExternalLink,
    title: "We find the direct site",
    description: "Our engine finds the property title and host name, then searches for their direct booking website.",
  },
  {
    icon: BadgeCheck,
    title: "Compare & save",
    description: "See the direct price side-by-side with the platform price. Book direct and keep more money in your pocket.",
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-secondary/50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight mb-4">
            How it works
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Three simple steps to unlock direct booking savings.
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
            >
              <div className="flex items-start gap-6 bg-card border rounded-2xl p-6 hover:shadow-card-hover transition-shadow">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-hero flex items-center justify-center">
                  <step.icon className="w-5 h-5 text-primary-foreground" />
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">Step {i + 1}</span>
                  </div>
                  <h3 className="font-display text-lg font-semibold mb-1">{step.title}</h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
              {i < steps.length - 1 && (
                <div className="flex justify-center py-1">
                  <ArrowDown className="w-4 h-4 text-muted-foreground/40" />
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
